import React, { useMemo, useState, useEffect } from "react"
import { Link, useHistory } from "react-router-dom"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import DeleteModal from "../../components/Common/DeleteModal"

import { SimpleStringValue } from "helpers/common_helper_functions"
import { SaveToast } from "components/Common/SaveToast"
import { Col, Row, UncontrolledTooltip, Card, CardBody } from "reactstrap"

import {
  deleteTrainingExam,
  getAllTrainingExam,
  updateTrainingExam,
} from "helpers/backendHelpers/trainingExam"

const TrainingExam = props => {
  document.title = "Training Exam | LMS Ghana"

  const [deleteModal, setDeleteModal] = useState(false)
  const [trainingExamList, setTrainingExamList] = useState([])
  const [trainingQuestion, setTrainingQuestion] = useState({})
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  useEffect(() => {
    fetchAllTrainingExam()
  }, [saved])

  const fetchAllTrainingExam = async () => {
    try {
      setLoading(true)
      const response = await getAllTrainingExam()
      let { trainingExam } = response.data || {}
      trainingExam = trainingExam || []
      setTrainingExamList(trainingExam)
      setLoading(false)
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Fetching Assignments"
      setTrainingExamList([])
      setLoading(false)
      return SaveToast({ message, type: "error" })
    }
  }

  const onClickDelete = TrainingQuestionData => {
    setTrainingQuestion(TrainingQuestionData)
    setDeleteModal(true)
  }

  const handleUpdateTrainingExamStatus = async (id, status) => {
    if (!id) {
      return SaveToast({
        message: "Please Enter Assignments Id",
        type: "error",
      })
    }
    try {
      const response = updateTrainingExam(id, { te_status: status })
      const message =
        response?.message || "Training Question Status Updated Successfully"
      SaveToast({ message, type: "success" })

      setSaved(prevSaved => !prevSaved)
      return
    } catch (error) {
      const message =
        error?.message || "There Was A Problem Updating Assignments Status"
      return SaveToast({ message, type: "error" })
    }
  }

  const handleDeleteAssigmentQuestion = async () => {
    if (!trainingQuestion.te_id) {
      return SaveToast({ message: "Invalid Training Exam ID", type: "error" })
    }
    try {
      const response = await deleteTrainingExam(trainingQuestion.te_id)
      const message = response?.message || "Training Exam Deleted Successfully"
      SaveToast({ message, type: "success" })

      setSaved(prevSaved => !prevSaved)
      setDeleteModal(false)
      return
    } catch (error) {
      const message =
        error?.message || "There was a problem deleting Training Exam"
      return SaveToast({ message, type: "error" })
    }
  }

  const handleAddButtonClick = () => {
    history.push({
      pathname: "/training-exam/add",
      state: {
        type: 1,
      },
    })
  }

  const handleBackButtonClick = () => {
    // props.history.push("/batch-creation/add")
    history.push({
      pathname: `/training-program`,
    })
  }

  const columns = useMemo(
    () => [
      {
        Header: "Title",
        accessor: "te_title",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Total Marks",
        accessor: "te_totalMarks",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Class/Grade",
        accessor: "te_category",
        filterable: false,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Subject",
        accessor: "te_subCategory",
        filterable: false,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Topic",
        accessor: "te_topic",
        filterable: false,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Status",
        accessor: "te_status",
        disableFilters: true,
        Cell: cellProps => {
          const cellData = cellProps.row.original
          return (
            <div className="form-check form-switch form-switch-md">
              <input
                type="checkbox"
                className="form-check-input bg-dark"
                id={`tc_status_checkbox-${cellData.te_id}`}
                name={`tc_status_checkbox-${cellData.te_id}`}
                defaultChecked={cellData.te_status}
                onChange={e => {
                  let { checked, name } = e.target
                  document.getElementById(name).checked = checked
                  return handleUpdateTrainingExamStatus(cellData.te_id, checked)
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to={{
                  pathname:
                    "/assignment-manage/" + cellProps.row.original.te_id,
                  state: {
                    type: 0,
                  },
                }}
                className="text-dark"
              >
                <i className="mdi mdi-file font-size-18" id="filetooltip" />
                <UncontrolledTooltip placement="top" target="filetooltip">
                  Manage Question
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-dark"
                onClick={() => {
                  props.history.push(
                    "/training-exam/view/" + cellProps.row.original.te_id
                  )
                }}
              >
                <i className="mdi mdi-eye font-size-18" id="viewtooltip" />
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  props.history.push(
                    "/training-exam/edit/" + cellProps.row.original.te_id
                  )
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const trainingExamData = cellProps.row.original
                  onClickDelete(trainingExamData)
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  const printColumns = useMemo(() => [
    {
      Header: "Title",
      accessor: "aq_title",
      filterable: false,
      Cell: cellProps => {
        return <SimpleStringValue {...cellProps} />
      },
    },
    {
      Header: "Marks",
      accessor: "aq_mark",
      filterable: true,
      Cell: cellProps => {
        return <SimpleStringValue {...cellProps} />
      },
    },
    {
      Header: "Answer Type",
      accessor: "aq_answerType",
      filterable: false,
      Cell: cellProps => {
        return <SimpleStringValue {...cellProps} />
      },
    },
    // {
    //   Header: "Correct Answer",
    //   accessor: "aq_correntAns",
    //   filterable: false,
    //   Cell: cellProps => {
    //     return <SimpleStringValue {...cellProps} />
    //   },
    // },
    {
      Header: "Status",
      accessor: "aq_status",
      disableFilters: true,
      Cell: cellProps => {
        return cellProps?.row?.original?.tc_status ? "Active" : "Inactive"
      },
    },
  ])

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteAssigmentQuestion}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={trainingExamList}
                    isGlobalFilter={true}
                    isAddOptions={true}
                    isBackOption={true}
                    addButtonLabel="Add Training Exam"
                    handleAddButtonClick={handleAddButtonClick}
                    handleBackButtonClick={handleBackButtonClick}
                    customPageSize={10}
                    className="custom-header-css"
                    dataFetchLoading={loading}
                    canExportCsv={true}
                    canPrint={true}
                    printColumns={printColumns}
                    noDataMessage="No system activity found."
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TrainingExam
